// extracted by mini-css-extract-plugin
export default {"coursesBlock":"CoursesBlock_coursesBlock__xZPJj","courseCardsList":"CoursesBlock_courseCardsList__9TfQD"};